<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OMHC3i/tc-custom/9781473841864.jpg?1728259324550" alt="This image is the cover for the book From the Dreadnought to Scapa Flow, Volume III"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From the Dreadnought to Scapa Flow, Volume III
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Volume III in this definitive WWI naval history presents an in-depth analysis of the Battle of Jutland, with a new introduction by historian Barry Gough.</b></p> Arthur Marder's five-volume history <i>From the Dreadnought to Scapa Flow</i> is one of the finest contributions to naval history, chronicling the dramatic conflicts of the First World War with an “unrivalled mastery of sources” and “a gift of simple narrative” (A.J.P. Taylor).<br/><br/> The third volume presents an in-depth analysis of the clash between the German High Seas fleet and the British Grand Fleet and Battlecruiser Fleet at Jutland, as well as its immediate aftermath. Marder's intricate charting of this great battle is still recognized as the authoritative statement on these events. A new introduction by Barry Gough, the distinguished Canadian maritime and naval historian, assesses the importance of Marder's work and anchors it firmly amongst the great naval narrative histories of this era.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Arthur J. Marder, Barry Gough
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen & Sword Books Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?262f6c3a